const nb = (min, max) => new Intl.NumberFormat("nb-NO", { minimumFractionDigits: min, maximumFractionDigits: max });

export const fmtBT = (v) => (v == null ? "" : nb(0, 2).format(v));
export const fmtRate = (v) => (v == null ? "" : nb(2, 4).format(v));
export const fmtNok = (v) => nb(2, 2).format(v || 0);
export const fmtInt = (v) => nb(0, 0).format(v || 0);

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "–";

export function parseNum(s) {
  const t = String(s ?? "").trim().replace(/[\s\u00a0]/g, "").replace(",", ".");
  if (t === "") return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : NaN;
}

export function passwordStrength(pw) {
  if (!pw) return { label: "Ukjent", tone: "slate" };
  const classes = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(pw)).length;
  if (pw.length >= 12 && classes >= 3) return { label: "Sterkt", tone: "emerald" };
  if (pw.length >= 8 && classes >= 2) return { label: "Middels", tone: "amber" };
  return { label: "Svakt", tone: "red" };
}

export function generatePassword() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!#%";
  const arr = new Uint32Array(14);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (n) => chars[n % chars.length]).join("");
}

export const newId = () => Math.random().toString(36).slice(2, 14);
